import {StoritevEnum} from '../Enum/StoritevEnum'

export default class OrderService {
  _serviceId = null
  _quantity = null
  _additionalData = {}
  _terminationPointId = null
  _customerId = null

  constructor (serviceId, quantity, terminationPointId = null, customerId = null) {
    this._serviceId = serviceId
    this._quantity = quantity
    this._terminationPointId = terminationPointId
    this._customerId = customerId
    if (serviceId === StoritevEnum.APLIKACIJA_T2_TV) {
      this.additionalData = {
        smartTvApp: null
      }
    }
  }
  addOrEditAditionalData (key, value) {
    this._additionalData[key] = value
  }

  getRequestItem () {
    let additionalDataArr = []

    Object.keys(this._additionalData).forEach((key) => {
      if (this._additionalData[key] !== null) {
        additionalDataArr.push({
          key: key,
          value: this._additionalData[key]
        })
      }
    })
    return {
      serviceId: this._serviceId,
      quantity: this._quantity,
      additionalData: additionalDataArr,
      terminationPointId: this._terminationPointId,
      customerId: this._customerId
    }
  }

  get additionalData () {
    return this._additionalData
  }

  set additionalData (value) {
    this._additionalData = value
  }

  get serviceId () {
    return this._serviceId
  }

  set serviceId (value) {
    this._serviceId = value
  }

  get quantity () {
    return this._quantity
  }

  set quantity (value) {
    this._quantity = value
  }

  get terminationPointId () {
    return this._terminationPointId
  }

  set terminationPointId (value) {
    this._terminationPointId = value
  }

  get customerId () {
    return this._customerId
  }

  set customerId (value) {
    this._customerId = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Order/OrderService.js